import React, { useState, useEffect } from "react";
import {
  Cookie,
  X,
  Shield,
  Settings,
  Check,
  ChevronLeft,
  TrendingUp,
  BarChart2,
} from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const Galleta = ({ isDarkMode }) => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [cookies, setCookies] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });
  const { language,  translations } = useLanguage();
  const cookiesPolicy = translations[language];
  const comunes = translations[language].politicaComunes;

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    const cookiePreferences = localStorage.getItem("cookiePreferences");

    if (!cookiesAccepted) {
      setTimeout(() => setShowBanner(true), 1000);
    } else if (cookiePreferences) {
      setCookies(JSON.parse(cookiePreferences));
    }
  }, []);

  const acceptAllCookies = () => {
    const allCookies = {
      necessary: true,
      analytics: true,
      marketing: true,
    };
    setCookies(allCookies);
    localStorage.setItem("cookiesAccepted", "true");
    localStorage.setItem("cookiePreferences", JSON.stringify(allCookies));
    setShowBanner(false);
  };

  const acceptSelectedCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    localStorage.setItem("cookiePreferences", JSON.stringify(cookies));
    setShowBanner(false);
    setShowSettings(false);
  };

  const rejectOptionalCookies = () => {
    const necessaryOnly = {
      necessary: true,
      analytics: false,
      marketing: false,
    };
    setCookies(necessaryOnly);
    localStorage.setItem("cookiesAccepted", "true");
    localStorage.setItem("cookiePreferences", JSON.stringify(necessaryOnly));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {(showSettings || showPolicy) && (
        <div
          className="fixed inset-0 bg-black/50 z-[9998] transition-opacity duration-300"
          onClick={() => {
            setShowSettings(false);
            setShowPolicy(false);
          }}
        />
      )}

      <div
        className={`fixed bottom-0 left-0 right-0 z-[9999] p-4 transition-transform duration-500 ${
          showBanner ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div
          className={`max-w-7xl mx-auto ${
            isDarkMode
              ? "bg-gray-900 border border-gray-700"
              : "bg-white border border-gray-200"
          } rounded-2xl shadow-2xl overflow-hidden`}
        >
          <div className="h-1 bg-gradient-to-r from-[#12A9B0] via-purple-500 to-[#12A9B0]"></div>

          <div className="p-6 pt-0 max-h-[80vh] overflow-y-auto">
            {!showSettings && !showPolicy ? (
              <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 pt-4">
                    <div className="p-2 bg-[#12A9B0]/10 rounded-lg">
                      <Cookie className="text-[#12A9B0]" size={24} />
                    </div>
                    <h3
                      className={`text-xl font-bold ${
                        isDarkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      {comunes.titulos.utilizamosCookies}
                    </h3>
                  </div>
                  <p
                    className={`text-sm leading-relaxed ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    {comunes.textos.descripcionCookies}{" "}
                    <button
                      onClick={() => setShowPolicy(true)}
                      className="text-[#12A9B0] hover:underline inline-flex items-center gap-1"
                    >
                      {comunes.titulos.politicaCookies.toLowerCase()}
                    </button>
                    .
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                  <button
                    onClick={rejectOptionalCookies}
                    className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 hover:scale-105 ${
                      isDarkMode
                        ? "bg-gray-800 text-gray-300 hover:bg-gray-700"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {comunes.botones.rechazar}
                  </button>

                  <button
                    onClick={() => setShowSettings(true)}
                    className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 ${
                      isDarkMode
                        ? "bg-gray-800 text-gray-300 hover:bg-gray-700"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    <Settings size={18} />
                    {comunes.botones.configurar}
                  </button>

                  <button
                    onClick={acceptAllCookies}
                    className="px-6 py-3 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-medium transition-all duration-300 hover:scale-105 hover:shadow-lg flex items-center justify-center gap-2"
                  >
                    <Check size={18} />
                    {comunes.botones.aceptarTodas}
                  </button>
                </div>
              </div>
            ) : showPolicy ? (
              <div className="space-y-6">
                <div
                  className={`flex items-center justify-between sticky top-0 z-10 pb-4 pt-4 border-b ${
                    isDarkMode
                      ? "border-gray-700 bg-gray-900"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => setShowPolicy(false)}
                      className={`p-2 rounded-lg transition-colors ${
                        isDarkMode
                          ? "text-white hover:bg-gray-800"
                          : "hover:bg-gray-100"
                      }`}
                    >
                      <ChevronLeft size={20} />
                    </button>
                    <h3
                      className={`text-xl font-bold ${
                        isDarkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      {cookiesPolicy.politicaCookies.titulo}
                    </h3>
                  </div>
                  <button
                    onClick={() => setShowPolicy(false)}
                    className={`p-2 rounded-lg transition-colors ${
                      isDarkMode
                        ? "text-white hover:bg-gray-800"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <X size={20} />
                  </button>
                </div>

                <p
                  className={`text-sm ${
                    isDarkMode ? "text-gray-500" : "text-gray-500"
                  }`}
                >
                  {cookiesPolicy.politicaCookies.fechaActualizacion}
                </p>

                {cookiesPolicy.politicaCookies.secciones.map(
                  (seccion, index) => (
                    <div key={index} className="space-y-3">
                      <h4
                        className={`font-semibold ${
                          isDarkMode ? "text-white" : "text-gray-900"
                        }`}
                      >
                        {seccion.titulo}
                      </h4>

                      {seccion.contenido && (
                        <p
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          {seccion.contenido}
                        </p>
                      )}

                      {seccion.subsecciones && (
                        <div className="space-y-4 ml-4">
                          {seccion.subsecciones.map((sub, subIndex) => (
                            <div
                              key={subIndex}
                              className={`p-4 rounded-lg ${
                                isDarkMode ? "bg-gray-800" : "bg-gray-50"
                              }`}
                            >
                              <h5
                                className={`font-medium mb-2 ${
                                  isDarkMode ? "text-white" : "text-gray-900"
                                }`}
                              >
                                {sub.tipo}
                              </h5>
                              <p
                                className={`text-sm mb-2 ${
                                  isDarkMode ? "text-gray-400" : "text-gray-600"
                                }`}
                              >
                                {sub.descripcion}
                              </p>
                              <p
                                className={`text-xs mb-2 ${
                                  isDarkMode ? "text-gray-500" : "text-gray-500"
                                }`}
                              >
                                Duración: {sub.duracion}
                              </p>
                              {sub.ejemplos && (
                                <ul className="list-disc list-inside text-xs space-y-1">
                                  {sub.ejemplos.map((ejemplo, i) => (
                                    <li
                                      key={i}
                                      className={
                                        isDarkMode
                                          ? "text-gray-500"
                                          : "text-gray-500"
                                      }
                                    >
                                      {ejemplo}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      {seccion.navegadores && (
                        <div className="flex flex-wrap gap-2 ml-4">
                          {seccion.navegadores.map((nav, navIndex) => (
                            <a
                              key={navIndex}
                              href={nav.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`px-3 py-1 rounded-lg text-xs transition-colors ${
                                isDarkMode
                                  ? "bg-gray-800 text-gray-400 hover:bg-gray-700"
                                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                              }`}
                            >
                              {nav.nombre}
                            </a>
                          ))}
                        </div>
                      )}

                      {seccion.datosContacto && (
                        <div
                          className={`ml-4 p-4 rounded-lg ${
                            isDarkMode ? "bg-gray-800" : "bg-gray-50"
                          }`}
                        >
                          <p
                            className={`text-sm ${
                              isDarkMode ? "text-gray-400" : "text-gray-600"
                            }`}
                          >
                            Email: {seccion.datosContacto.email}
                            <br />
                            Dirección: {seccion.datosContacto.direccion}
                            <br />
                            Teléfono: {seccion.datosContacto.telefono}
                          </p>
                        </div>
                      )}
                    </div>
                  )
                )}

                <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                  <button
                    onClick={() => setShowPolicy(false)}
                    className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                      isDarkMode
                        ? "bg-gray-800 text-gray-300 hover:bg-gray-700"
                        : "bg-gray-100 text-white hover:bg-gray-200"
                    }`}
                  >
                    Volver
                  </button>
                </div>
              </div>
            ) : (
              <div className="space-y-6">
                <div className="space-y-6">
                  <div className="flex items-center justify-between pt-4">
                    <h3
                      className={`text-xl font-bold ${
                        isDarkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      {comunes.titulos.configuracionCookies}
                    </h3>
                    <button
                      onClick={() => setShowSettings(false)}
                      className={`p-2 rounded-lg transition-colors ${
                        isDarkMode ? "text-white hover:bg-gray-800" : "hover:bg-gray-100"
                      }`}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <div className="space-y-4">
                    <div
                      className={`p-4 rounded-lg ${
                        isDarkMode ? "bg-gray-800" : "bg-gray-50"
                      }`}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <Shield className="text-green-500" size={20} />
                            <h4
                              className={`font-semibold ${
                                isDarkMode ? "text-white" : "text-gray-900"
                              }`}
                            >
                              {comunes.tiposCookies.necesarias}
                            </h4>
                            <span className="px-2 py-0.5 bg-green-500/10 text-green-600 text-xs rounded-full">
                              {comunes.estados.siempreActivas}
                            </span>
                          </div>
                          <p
                            className={`text-sm ${
                              isDarkMode ? "text-gray-400" : "text-gray-600"
                            }`}
                          >
                            {comunes.textos.cookiesNecesarias}
                          </p>
                        </div>
                        <input
                          type="checkbox"
                          checked={true}
                          disabled
                          className="w-5 h-5 rounded cursor-not-allowed opacity-50"
                        />
                      </div>
                    </div>

                    <div
                      className={`p-4 rounded-lg ${
                        isDarkMode ? "bg-gray-800" : "bg-gray-50"
                      }`}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <TrendingUp className="text-blue-500" size={20} />
                            <h4
                              className={`font-semibold ${
                                isDarkMode ? "text-white" : "text-gray-900"
                              }`}
                            >
                              {comunes.tiposCookies.analiticas}
                            </h4>
                          </div>
                          <p
                            className={`text-sm ${
                              isDarkMode ? "text-gray-400" : "text-gray-600"
                            }`}
                          >
                            {comunes.textos.cookiesAnaliticas}
                          </p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={cookies.analytics}
                            onChange={(e) =>
                              setCookies({
                                ...cookies,
                                analytics: e.target.checked,
                              })
                            }
                            className="sr-only peer"
                          />
                          <div
                            className={`w-11 h-6 rounded-full peer ${
                              isDarkMode ? "bg-gray-700" : "bg-gray-200"
                            } peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#12A9B0]`}
                          ></div>
                        </label>
                      </div>
                    </div>

                    <div
                      className={`p-4 rounded-lg ${
                        isDarkMode ? "bg-gray-800" : "bg-gray-50"
                      }`}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-2">
                            <BarChart2 className="text-purple-500" size={20} />
                            <h4
                              className={`font-semibold ${
                                isDarkMode ? "text-white" : "text-gray-900"
                              }`}
                            >
                              {comunes.tiposCookies.marketing}
                            </h4>
                          </div>
                          <p
                            className={`text-sm ${
                              isDarkMode ? "text-gray-400" : "text-gray-600"
                            }`}
                          >
                            {comunes.textos.cookiesMarketing}
                          </p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={cookies.marketing}
                            onChange={(e) =>
                              setCookies({
                                ...cookies,
                                marketing: e.target.checked,
                              })
                            }
                            className="sr-only peer"
                          />
                          <div
                            className={`w-11 h-6 rounded-full peer ${
                              isDarkMode ? "bg-gray-700" : "bg-gray-200"
                            } peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#12A9B0]`}
                          ></div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <button
                      onClick={rejectOptionalCookies}
                      className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                        isDarkMode
                          ? "bg-gray-800 text-gray-300 hover:bg-gray-700"
                          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                    >
                      {comunes.botones.rechazarTodas}
                    </button>
                    <button
                      onClick={acceptSelectedCookies}
                      className="px-6 py-3 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-medium transition-all duration-300 hover:scale-105 hover:shadow-lg"
                    >
                      {comunes.botones.guardarConfiguracion}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Galleta;
